// extracted by mini-css-extract-plugin
export default {"affix":"Affix_affix__gpK7E","videoportolayout":"Affix_videoportolayout__GL7H4","videolist":"Affix_videolist__NqC3O","normal":"Affix_normal__2Ho7Z"};